"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _recharts = require("recharts");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledPie = ({ outerRadius, data, children }) => {
  return _react2.default.createElement(
    _recharts.Pie,
    {
      data: data,
      dataKey: "value",
      cx: "50%",
      cy: "50%",
      outerRadius: outerRadius,
      labelLine: false
    },
    children
  );
};

const RADIAN = Math.PI / 180;
const PercentageLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return _react2.default.createElement(
    "text",
    {
      x: x,
      y: y,
      fill: "white",
      textAnchor: "middle",
      dominantBaseline: "central"
    },
    `${(percent * 100).toFixed(0)}%`
  );
};

const PriceLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return _react2.default.createElement(
    "text",
    {
      x: x,
      y: y,
      fill: "white",
      textAnchor: "middle",
      dominantBaseline: "central"
    },
    `$${value}`
  );
};

const NameLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return _react2.default.createElement(
    "text",
    {
      x: x,
      y: y,
      fill: "white",
      textAnchor: "middle",
      dominantBaseline: "central"
    },
    name
  );
};

const getRandomColor = () => Math.floor(Math.random() * 16777215).toString(16);

const Charts = ({
  data,
  outerRadius,
  tooltip,
  fill,
  donut,
  showLabel,
  paddingAngle,
  percentage,
  showName,
  price
}) => {
  const Colors = data.map(() => `#${getRandomColor()}`);

  let pieProps = {};

  if (donut) {
    pieProps["innerRadius"] = outerRadius / 2;
  }

  if (showName) {
    pieProps["label"] = _react2.default.createElement(NameLabel, null);
  }

  if (showLabel && percentage) {
    pieProps["label"] = _react2.default.createElement(PercentageLabel, null);
  }

  if (showLabel && price) {
    pieProps["label"] = _react2.default.createElement(PriceLabel, null);
  }

  if (paddingAngle) {
    pieProps["paddingAngle"] = paddingAngle;
  }

  return _react2.default.createElement(
    _Box2.default,
    null,
    _react2.default.createElement(
      _recharts.PieChart,
      { width: outerRadius * 2, height: outerRadius * 2 },
      _react2.default.createElement(
        _recharts.Pie,
        _extends({
          data: data,
          dataKey: "value",
          cx: "50%",
          cy: "50%",
          outerRadius: outerRadius,
          labelLine: false
        }, pieProps),
        data.map((entry, index) => _react2.default.createElement(_recharts.Cell, { key: `cell-${index}`, fill: fill || Colors[index] }))
      ),
      tooltip && _react2.default.createElement(_recharts.Tooltip, null)
    )
  );
};

Charts.defaultProps = {
  donut: false,
  percentage: false,
  price: false,
  paddingAngle: 0,
  showLabel: false,
  fill: null,
  showName: true,
  tooltip: true,
  outerRadius: 90,
  data: [{ name: "Group A", value: 400 }, { name: "Group B", value: 300 }, { name: "Group C", value: 300 }, { name: "Group D", value: 200 }]
};

exports.default = Charts;